<div *ngIf="detailsInput != null" style="margin-top:70px">
  <div class="page-navigation-container">
    <app-side-scrolling [maxLengthOfDisplayed]="maxLengthOfProcesses()"
                        (notifyCurrentSite)="setCurrentProcessSite($event)"
                        (notifyDisplayedSites)="setNumberOfDisplayedPackages($event)"></app-side-scrolling>
  </div>
  <div class="table-container">
    <table class="az-data-table">
      <thead>
      <tr>
        <th *ngFor="let labelAnzeige of labelAnzeigeTabelleHeader">
          {{labelAnzeige.label}}
        </th>
      </tr>
      </thead>
      <tbody>
      <ng-container *ngFor="let maklerPaketStatusDetail of maklerPaketStatusDetails">
        <tr>
          <td>
            {{maklerPaketStatusDetail.name}}
          </td>
          <td>
            {{maklerPaketStatusDetail.erstellzeitpunkt}}
          </td>
          <td>
            {{maklerPaketStatusDetail.status}}
          </td>
          <a [routerLink]="" style="float:left; margin-left:30px" (click)="showGeschaeftsvorgang(maklerPaketStatusDetail.geschaeftsvorgangs)">
            <span *ngIf="maklerPaketStatusDetail.geschaeftsvorgangs[0].ordnungsmerkmalExtern!='undefined'">details</span>
          </a>
          <a [routerLink]="" style="float:right; margin-right:40px" (click)="downloadCSV(maklerPaketStatusDetail.geschaeftsvorgangs, maklerPaketStatusDetail.lieferungId)">
            csv
          </a>
        </tr>
      </ng-container>
      </tbody>
    </table>
  </div>
  <div *ngIf="canDisplayGeschaeftsvorgang">
    <!--<div class="page-navigation-container">-->
      <!--<app-side-scrolling [maxLengthOfDisplayed]="maxLengthOfGV()"-->
                          <!--(notifyCurrentSite)="setCurrentGVSite($event)"-->
                          <!--(notifyDisplayedSites)="setNumberOfDisplayedGV($event)"></app-side-scrolling>-->
    <!--</div>-->
    <div class="table-container">
      <table class="az-data-table">
        <thead>
        <tr>
          <th *ngFor="let labelAnzeigeGeschaeftsvorgang of labelGeschaeftsvorgangTabelleHeader">
            {{labelAnzeigeGeschaeftsvorgang.label}}
          </th>
        </tr>
        </thead>
        <tbody>
        <ng-container *ngFor="let geschaftsvorg of gv">
          <tr>
            <td>
              {{geschaftsvorg.ordnungsmerkmalExtern}}
            </td>
            <td>
              {{geschaftsvorg.gevoArtWert}}
            </td>
            <td>
              {{geschaftsvorg.vertragIDAllianz}}
            </td>
            <td>
              {{geschaftsvorg.statusWert}}
            </td>
          </tr>
        </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>





